module.exports = __webpack_public_path__ + "img/4.017f6b06.gif";